<template lang="pug">
form.form-horizontal
  .form-group
    label.col-md-12 HTML
      .col-md-12
      el-input(type='textarea', :value="value['layer_html']", :rows='5', placeholder='',@input="inputData($event, 'layer_html')")
  .form-group(v-for='(item, index) in items')
    label.col-md-12 {{item.label}}
      .col-md-12
      el-input(type='text', :value="value[item.name]",@input="inputData($event, item.name)")
</template>
        
    <script>
    export default {
      name: 'Top',
      props: ['value'],
      data () {
        return {
          locale_url: {
            ja: '',
            en: '',
            cn: '',
            kr: ''
          },
          items: [
            {
              name: 'data-frames',
              label: 'data-frames'
            },
            {
              name: 'data-x',
              label: 'data-x'
            },
            {
              name: 'data-y',
              label: 'data-y'
            },
            {
              name: 'data-hoffset',
              label: 'data-hoffset'
            },
            {
              name: 'data-voffset',
              label: 'data-voffset'
            },
            {
              name: 'data-fontsize',
              label: 'data-fontsize'
            },
            {
              name: 'data-lineheight',
              label: 'data-lineheight'
            },
            {
              name: 'data-width',
              label: 'data-width'
            },
            {
              name: 'data-height',
              label: 'data-height'
            },
            {
              name: 'data-whitespace',
              label: 'data-whitespace'
            },
            {
              name: 'data-type',
              label: 'data-type'
            },
            {
              name: 'data-responsive_offset',
              label: 'data-responsive_offset'
            },
            {
              name: 'data-textAlign',
              label: 'data-textAlign'
            },
            {
              name: 'data-paddingtop',
              label: 'data-paddingtop'
            },
            {
              name: 'data-paddingright',
              label: 'data-paddingright'
            },
            {
              name: 'data-paddingbottom',
              label: 'data-paddingbottom'
            },
            {
              name: 'data-paddingleft',
              label: 'data-paddingleft'
            },
            {
              name: 'data-basealign',
              label: 'data-basealign'
            },
            {
              name: 'style',
              label: 'style'
            }
          ]
        }
      },
      components: {
      },
      methods: {
        inputData (event, name) {
          this.value[name] = event
        }
      }
    }
    </script>
        
    <style scoped>
    </style>


// WEBPACK FOOTER //
// src/views/components/swan/layer/TextParameter.vue